import React from 'react'

export default React.createContext({
    menuSelect: 'home',
    setMenuSelect: (value) => {},
    showtimeOn: 'off',
    setShowtimeOn: (value) => {}
})